<template>
  <header
    class="flex justify-between lg:hidden bg-[#09518C]"
    data-dev-hint="mobile menu bar"
  >
    <div class="flex justify-between p-4 text-white">
      <div>
        <p class="font-bold">Access ARM Pension Employer Portal</p>
      </div>
      <div class="lg:flex hidden">
        <div
          class="bg-white text-[#09518c] rounded-full w-8 h-8 flex items-center justify-center"
        >
          <font-awesome-icon icon="fa-briefcase" />
        </div>
        <div class="px-4 flex items-center justify-center">
          <span> Welcome, {{ $store.state.getLoggedInUser?.name }} </span>
        </div>
      </div>
    </div>

    <label
      for="menu-open"
      id="mobile-menu-button"
      class="m-2 p-2 focus:outline-none hover:text-white rounded-lg"
    >
      <font-awesome-icon
        id="menu-close-icon"
        class="h-6 w-6 transition duration-200 ease-in-out text-white cursor-pointer"
        icon="fa-bars"
      />
    </label>
  </header>
</template>

<script>
export default {};
</script>

<style scoped>
#menu-open:checked ~ #sidebar {
  --tw-translate-x: 0;
}

#menu-open:checked ~ * #menu-open-icon {
  display: none;
}

#menu-open:checked ~ * #menu-close-icon {
  display: block;
}
</style>
